import { setText } from '../dom-helpers.js';

// Mounts a transient toast warning the user that FPS dropped. The toast
// auto-dismisses after `dismissMs` and the helper returns a manual cleanup
// in case the parent unmounts earlier.
export function showFpsWarningToast(
  root: HTMLElement,
  opts: { fps: number; dismissMs?: number } = { fps: 0 },
): () => void {
  const dismissMs = opts.dismissMs ?? 6000;

  const toast = document.createElement('div');
  toast.classList.add('viewer-ui-interactive');
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.style.cssText =
    'position:fixed;bottom:3.5rem;right:0.75rem;max-width:18rem;background:rgba(120,53,15,0.92);backdrop-filter:blur(6px);color:#fef3c7;padding:0.5rem 0.75rem;border-radius:0.375rem;font-family:system-ui,sans-serif;font-size:0.75rem;line-height:1.4;z-index:12;pointer-events:auto';

  setText(
    toast,
    `Performance ridotta (${Math.round(opts.fps)} FPS). Modello complesso per il dispositivo: prova a decimare con SuperSplat prima di pubblicare.`,
  );
  root.appendChild(toast);

  const timer = setTimeout(() => {
    toast.remove();
  }, dismissMs);

  return () => {
    clearTimeout(timer);
    toast.remove();
  };
}
